var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-nav-item',{staticClass:"mr-2",on:{"click":_vm.toggle}},[_c('font-awesome-icon',{attrs:{"icon":_vm.fullscreen ? 'compress' : 'expand'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }